import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ shape, custom, palette }: Theme) => ({
  modalContent: {
    width: '100%',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  img: {},
  heading: {
    fontSize: 32,
    color: custom.grey[3],
    fontFamily: 'Merriweather',
    fontWeight: 900,
    width: '100%',
    '& > h4': {
      margin: 0,
      padding: '20px 0',
    },
  },
  bulletpoint: {
    display: 'flex',
    fontSize: 16,
    color: custom.grey[3],
    '& > p': {
      margin: '5px 0',
    },
    '&:last-of-type': {
      marginBottom: 7,
    },
  },
  icon: {
    display: 'inline-block',
    color: custom.status.success.contrastText,
    marginRight: 10,
  },
  description: {
    marginTop: 22,
    marginBottom: 20,
    fontSize: 16,
    lineHeight: 1.44,
    color: custom.grey[3],
  },
  consent: {
    margin: 0,
    padding: 15,
    borderRadius: 5,
    display: 'flex',
    backgroundColor: custom.grey[8],
    alignItems: 'flex-start',
    '& > span:nth-child(1)': {
      position: 'relative',
      left: -11,
      top: -11,
    },
    '& > span:nth-child(2)': {
      marginLeft: -13,
      color: custom.grey[3],
      fontSize: 12,
      lineHeight: 1.5,
      fontWeight: 'normal',
      letterSpacing: 'normal',
    },
  },
  consentError: {
    '& > span:nth-child(2)': {
      color: custom.status.danger.contrastText,
    },
  },
  submitButton: {
    margin: '20px 0',
    minHeight: 50,
    fontSize: 16,
    fontWeight: 900,
    '&:disabled': {
      backgroundColor: `${palette.primary.main} !important`,
      color: `${palette.common.white} !important`,
      opacity: 0.3,
    },
  },
  labelWrapper: {
    position: 'relative',
    marginLeft: 10,
  },
  requiredFielAsterisk: {
    fontSize: 16,
    color: palette.primary.main,
    position: 'absolute',
    left: '-14px',
  },
  footerSection: {
    borderTop: `solid 1px ${custom.grey[14]}`,
    paddingTop: 20,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
  },
  footerText: {
    color: custom.grey[10],
    marginTop: 0,
    fontSize: 14,
  },
}));
